module.exports = __webpack_public_path__ + "media/images/services/thumbnail/img_ceremony-8ed417511c25e6fb10d91672661a4254.jpg";